// extracted by mini-css-extract-plugin
export var button = "rgpd-module--button--16a4a";
export var buttons = "rgpd-module--buttons--3d465";
export var container = "rgpd-module--container--f64e9";
export var optOut = "rgpd-module--optOut--f8a1d";
export var text = "rgpd-module--text--ea208";
export var wrapper = "rgpd-module--wrapper--2df71";